/**
 *  Import node modules
 */
import { createSelector } from 'reselect'

/**
 *  Select the portion of the root reducer
 */
export const imageCropping = () => state => state.get('imageCropping');

/**
 *  Select =is Uploading
 */
export const getIsUploadingImage = () =>
  createSelector(imageCropping(), state => {
    return state.get('isUploadingImage')
  })
